export default "__VITE_ASSET__wOZWPxnH__"